import type { FC, ReactNode } from 'react'

import LegalPage from '@/components/templates/legal-page'

const SECTIONS = [
    {
        heading: "About this website",
        paragraphs: [
            "This website is run by ACM Services LLC, trading as The ACM Pros, based in Madison, Alabama. Alabama license #307601. By using the site you agree to these terms."
        ]
    },
    {
        heading: "Information on this site",
        paragraphs: [
            "Our pages and articles give general guidance about exterior windows, doors, siding, roofing and washing in North Alabama. Every home is different, so this guidance is not a quote, an inspection or professional advice for your specific property."
        ]
    },
    {
        heading: "Estimates and work",
        paragraphs: [
            "Sending the estimate form does not create a contract. Prices are only set in a written estimate after we visit and measure. Any work we carry out is covered by the written agreement for that job, which takes priority over anything on this website.",
            "We only work on the outside of homes and buildings. We do not install interior doors or interior windows or carry out interior remodeling."
        ]
    },
    {
        heading: "Photos",
        paragraphs: [
            "Photos marked “ACM job photo” are from our own jobs. Images marked “Illustration” show the style of work and are not our projects. Photos of local places are credited to their owners where required."
        ]
    },
    {
        heading: "Acceptable use",
        paragraphs: [
            "Please do not misuse the site, including by sending false requests, trying to break into it, or copying its content for commercial use without permission."
        ]
    },
    {
        heading: "Links",
        paragraphs: [
            "Links to other websites, such as Google, Facebook and Instagram, are provided for convenience. We are not responsible for their content."
        ]
    },
    {
        heading: "Governing law",
        paragraphs: [
            "These terms are governed by the laws of the State of Alabama."
        ]
    },
    {
        heading: "Questions",
        paragraphs: [
            "Call us at (256) 585-6817, Monday to Saturday, 7 AM to 7 PM."
        ]
    }
]

const TermsOfService: FC = (): ReactNode => (
    <LegalPage
        title="Terms of service"
        seoTitle="Terms of Service"
        description="The terms for using The ACM Pros website, including how estimates work and what the information on this site is for."
        path='/terms-of-service/'
        updated="October 2026"
        intro="These short terms explain how this website may be used and how it relates to any work we do for you."
        sections={SECTIONS}
    />
)

export default TermsOfService
